/**
 * 路由切換時，將仍展開（或收合／展開動畫中）的導覽列選單立即收合，
 * 並同步漢堡按鈕的 ARIA 狀態，避免半透明選單疊層遮蔽新頁面的中央內容。
 * 對應無障礙準則 CS1140101E（焦點呈現需可辨識、不可被遮蔽）。
 */
export function collapseWebNavbars() {
  const targets = document.querySelectorAll(
    '.navbar-collapse.show, .navbar-collapse.collapsing'
  )
  if (!targets.length) return

  // B-2：導覽收合期間停用 transition，使收合瞬間完成、無 350ms 動畫殘留
  document.body.classList.add('nav-collapse-instant')

  targets.forEach((el) => {
    const Collapse = window.bootstrap && window.bootstrap.Collapse
    if (Collapse) {
      // 交由 Bootstrap 收合，維護其內部狀態與 _triggerArray
      Collapse.getOrCreateInstance(el, { toggle: false }).hide()
    }

    // 兜底：hide() 因動畫中（_isTransitioning）早退，或無 window.bootstrap 時，強制清狀態
    if (el.classList.contains('show') || el.classList.contains('collapsing')) {
      el.classList.remove('show', 'collapsing')
      el.style.height = ''
    }

    // 同步對應漢堡按鈕的 aria-expanded 與 collapsed class
    if (el.id) {
      document
        .querySelectorAll(`[data-bs-target="#${el.id}"], [aria-controls="${el.id}"]`)
        .forEach((toggler) => {
          if (!toggler.classList.contains('navbar-toggler')) return
          toggler.classList.add('collapsed')
          toggler.setAttribute('aria-expanded', 'false')
        })
    }
  })

  requestAnimationFrame(() => {
    document.body.classList.remove('nav-collapse-instant')
  })
}

/**
 * 路由切換後將焦點移至新頁的中央內容起點（#main-content），
 * 避免焦點掉回 <body> 或停留在已被移除的導覽連結上。
 * 頁面為延遲載入，故以 requestAnimationFrame 重試直到元素掛載。
 */
export function focusMainContent(retries = 30) {
  const main = document.getElementById('main-content')
  if (main) {
    main.focus({ preventScroll: true })
    return
  }
  if (retries > 0) {
    requestAnimationFrame(() => focusMainContent(retries - 1))
  }
}
